<div class="feature-row">
  <div class="feature-row__media" *ngIf="imagePosition === 'left'">
    <img [src]="image" [alt]="imageAlt" [attr.style]="imageStyle || null" />
  </div>

  <div class="feature-row__content">
    <h2 class="feature-row__heading" *ngIf="headingLevel === 'h2' && heading">{{ heading }}</h2>
    <h3 class="feature-row__heading feature-row__heading--h3" *ngIf="headingLevel === 'h3' && heading">{{ heading }}</h3>

    <p class="feature-row__paragraph" *ngFor="let para of paragraphs" [innerHTML]="para"></p>

    <ul class="feature-row__list" *ngIf="listStyle === 'plain'">
      <li *ngFor="let item of listItems">{{ item }}</li>
    </ul>

    <div
      class="feature-row__checklist"
      [class.feature-row__checklist--2col]="checklistColumns === 2"
      *ngIf="listStyle === 'check'"
    >
      <div
        class="feature-row__check-item"
        [class.feature-row__check-item--sm]="checkIconSize === 'sm'"
        *ngFor="let item of listItems"
      >
        <svg
          class="feature-row__check-icon"
          [class.feature-row__check-icon--sm]="checkIconSize === 'sm'"
          [class.feature-row__check-icon--lg]="checkIconSize === 'lg'"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 21 22"
          fill="none"
        >
          <path
            d="M9.63867 14.2422C9.39258 14.4883 8.94141 14.4883 8.69531 14.2422L6.07031 11.6172C5.82422 11.3711 5.82422 10.9199 6.07031 10.6738C6.31641 10.4277 6.76758 10.4277 7.01367 10.6738L9.1875 12.8477L13.9453 8.04883C14.1914 7.80273 14.6426 7.80273 14.8887 8.04883C15.1348 8.29492 15.1348 8.74609 14.8887 8.99219L9.63867 14.2422ZM21 11.125C21 16.9492 16.2832 21.625 10.5 21.625C4.67578 21.625 0 16.9492 0 11.125C0 5.3418 4.67578 0.625 10.5 0.625C16.2832 0.625 21 5.3418 21 11.125ZM10.5 1.9375C5.41406 1.9375 1.3125 6.08008 1.3125 11.125C1.3125 16.2109 5.41406 20.3125 10.5 20.3125C15.5449 20.3125 19.6875 16.2109 19.6875 11.125C19.6875 6.08008 15.5449 1.9375 10.5 1.9375Z"
            fill="currentColor"
          />
        </svg>
        <p class="feature-row__check-text">{{ item }}</p>
      </div>
    </div>

    <a
      class="feature-row__button"
      *ngIf="buttonLabel"
      [routerLink]="buttonLink"
      [queryParams]="buttonQueryParams"
    >
      <span>{{ buttonLabel }}</span>
      <svg
        *ngIf="buttonIcon"
        class="feature-row__button-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
      >
        <path
          d="M2.34766 0.9375L8.78125 7.65234C8.92188 7.82812 9.02734 8.03906 9.02734 8.25C9.02734 8.46094 8.92188 8.67188 8.78125 8.8125L2.34766 15.5273C2.03125 15.8789 1.46875 15.8789 1.15234 15.5625C0.800781 15.2461 0.800781 14.7188 1.11719 14.3672L7.02344 8.21484L1.11719 2.09766C0.800781 1.78125 0.800781 1.21875 1.15234 0.902344C1.46875 0.585938 2.03125 0.585938 2.34766 0.9375Z"
          fill="currentColor"
        />
      </svg>
    </a>
  </div>

  <div class="feature-row__media" *ngIf="imagePosition === 'right'">
    <img [src]="image" [alt]="imageAlt" [attr.style]="imageStyle || null" />
  </div>
</div>
